import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LucideAngularModule, X } from 'lucide-angular';

@Component({
  selector: 'app-modal-shell',
  standalone: true,
  imports: [CommonModule, LucideAngularModule],
  templateUrl: './modal-shell.component.html',
  styleUrls: ['./modal-shell.component.scss']
})
export class ModalShellComponent {
  readonly xIcon = X;

  @Input() isOpen = false;
  @Input() title = '';
  @Input() closeTitle = 'Fechar';
  @Input() panelClass = '';
  @Input() bodyClass = '';
  @Input() bodyScrollable = true;
  @Input() closeOnBackdropClick = true;

  @Output() fechado = new EventEmitter<void>();

  onBackdropClick(): void {
    if (this.closeOnBackdropClick) {
      this.fechado.emit();
    }
  }
}